angular.module('impactx.relationView').directive('appRelationView', [function() {
    return {
        scope: {
            assigned: '=',
            available: '=',
            filteredLeft: '=',
            filteredRight: '=',
            relation: '=',
            trns: '=',
            labelLeft: '@labelLeft',
            labelRight: '@labelRight',
            useXOrder: '=',
            relationId: "=",
            readOnly: "=",
            secondRelation: "=",
            changedMarker: "=",
            externalSearchRight: "=",
            firstFilterEntryPoint: "@",
            ixEventHandler: "=",
            listOrder: "=",
            availableEntryPoint: "@",
            minFilterLength: "@",
            baseId: "=",
            hasBaseReference: "=",
            canSort: "=",
            additionalFilter: "=",
            showSearchList: "=",
            maxNumber: "="
        },
        restrict: 'E',
        templateUrl: 'shared/relation-view/templates/relationTemplateDialog.html',
        link: function(scope, element) {
            var formController = element.controller('form');
            if(formController) {
                scope.formController = formController;
            }
        }
    };
}
]).factory('RelationViewHelperService', function DataGenerator() {
    var self = this;

    self.replaceForSrc = function(src, sourceCollectionToReplace, replacementCollection) {
        var idx, copyOfCollectionToModify = [], collectionToAdd = [], collectionAfterRemove;

        copyOfCollectionToModify = angular.copy(sourceCollectionToReplace, copyOfCollectionToModify);

        collectionAfterRemove = copyOfCollectionToModify.filter(function(el) {
            // console.log("Check: ", el.src, src);
            if(src && src.length > 0 && el.src && el.src.length > 0) {
                return src !== el.src;
            }
            //Src not specified, i.e. should not be affected by this filtering.
            return true;
        });

        if(replacementCollection) {
            //Adding collection means, that the collection should have values for the given source identifier
            collectionToAdd = replacementCollection.filter(function(el) {
                // console.log("Add collection filter: ", src, el.src);
                return src && (src.length > 0) && (src === el.src);
            });
        }

        if(collectionToAdd) {
            for(idx = 0; idx < collectionToAdd.length; idx++) {
                if(collectionToAdd[idx]) {
                    collectionAfterRemove.push(collectionToAdd[idx]);
                }
            }
        }

        return collectionAfterRemove;
    };

    return {
        replaceForSrc: self.replaceForSrc
    };
});
